export const ModuleInfotoolsActionTypes = {
  API_RESPONSE_SUCCESS: '@@modules-infotools/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@modules-infotools/API_RESPONSE_ERROR',

  GET_MODULE_INFOTOOLS: '@@modules-infotools/GET_MODULE_INFOTOOLS',
  LIST_MODULES_INFOTOOLS: '@@modules-infotools/LIST_MODULES_INFOTOOLS',
  // ADD_MODULE_INFOTOOLS: '@@modules-infotools/ADD_MODULE_INFOTOOLS',
  // UPDATE_MODULE_INFOTOOLS: '@@modules-infotools/UPDATE_MODULE_INFOTOOLS',
  // DELETE_MODULE_INFOTOOLS: '@@modules-infotools/DELETE_MODULE_INFOTOOLS',

  RESET: '@@modules-infotools/RESET'
}
